import ListInvites from "./data/list/ListInvites";

export default function SettingsInvites() {
  return (
    <>
      <ListInvites />
    </>
  );
}
